import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import moment from 'moment';

interface MiaxcarListState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    lastMeta: {
        page: number;
        pageSize: number;
        totalCount: number;
        totalPages: number;
    };

    documents: any[];
}

const state: MiaxcarListState = {
    loading: false,
    loaded: false,
    fatalError: false,

    lastMeta: {
        page: 0,
        pageSize: 0,
        totalCount: 0,
        totalPages: 0
    },

    documents: [],
};

export const ITEMS_LIST = 'GET_MIXCART_LIST';

export const actions: ActionTree<MiaxcarListState, RootState> = {
    loadData({ commit, getters, dispatch }, query) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            const columns: any = {
                "id": "md.id",
                "deal_id": "md.deal_id",
                "deal_name": "d.name",
                "deal_date": "d.expected_delivery_date",
                "mixcart_id": "md.mixcart_id",
                "created_at": "md.created_at",
                "payload": "md.payload",
            };

            const filter: any[] = [];

            if (query.name) {
                filter.push({ "$ilike": ["d.name", {"$": `%${query.name}%`}] })
            }
            if (query.mixcart_id) {
                filter.push({ "$eq": ["md.mixcart_id", {"$": query.mixcart_id}] })
            }
            if (query.created_at) {
                filter.push({ "$gt": ["md.created_at", {"$": moment(query.created_at).format('YYYY-MM-DD 00:00:00')}] })
                filter.push({ "$lt": ["md.created_at", {"$": moment(query.created_at).add(1, 'day').format('YYYY-MM-DD 00:00:00')}] })
            }

            vm.$db([
                vm.$q(ITEMS_LIST)
                .raw('documents.list')
                .action({
                    "columns": columns,
                    "from": "s:mixcart_deals",
                    "from_as": "md",
                    joins: [
                        {
                            join: 's:deals',
                            as: 'd',
                            on: {
                                "$eq": ["d.id", "md.deal_id"]
                            }
                        }
                    ],
                    page_size: 10,
                    ...({page: parseInt(query.page) || 1}),
                    ...({
                        order: [
                            query.sortDirection == 'asc' ? { $asc: [columns[query.sortField || 'id' ]] } : { $desc: [columns[query.sortField || 'id']] }
                        ]
                    }),
                    ...(
                        filter.length > 1 ?
                        {
                            "where": {
                                "$and": filter
                            }
                        } : {
                            "where": filter[0]
                        }
                    )

                })
            ]).then(((result: ServerResult) => {
                commit('SET_ITEMS_LIST', result.getOperation(ITEMS_LIST).getContent());
                commit('LOADED_SUCCESS');

                resolve();
            })).catch((error: any) => {
                commit('LOADED_ERROR');
                reject(error)
            })
        })
    },

    saveTodoType({ commit, getters, dispatch }, data) {
        const vm = (this as any)._vm;

        const query = data.id ?
            vm.$q('SAVE_DOCUMENT').update(data.id, data) :
            vm.$q('SAVE_DOCUMENT').create('voc_lines', data);

        return new Promise((resolve, reject) => {
            vm.$db([
                query
            ]).then((result: ServerResult) => {
                const operationResult = result.getOperation('SAVE_DOCUMENT');

                if (operationResult.hasError()) {
                    reject();
                } else {
                    resolve(operationResult.getContent());
                }
            })
            .catch((error: any) => {
                console.error('errror', error)
                reject(error);
            });
        });
    },

};

export const mutations: MutationTree<MiaxcarListState> = {
    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = true;
    },

    SET_ITEMS_LIST(state, data) {
        state.documents = data.documents;

        state.lastMeta = {
            page: data.meta.page,
            pageSize: data.meta.page_size,
            totalCount: data.meta.total_count,
            totalPages: data.meta.total_pages
        };
    },
};

const getters = {

};

export const STORE_KEY = '$_mixcart_list';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
